<template>
    <v-chip @click="goto()" small class="mr-2 mb-2 light-blue lighten-1">
        <v-avatar left>
            <v-icon small color="white">mdi-magnify</v-icon> </v-avatar
        ><label style="color:white;">Go to CDAX</label>
    </v-chip>
</template>

<script>
//`https://hpcdax.crm.dynamics.com/multientityquickfind/multientityquickfind.aspx?sitemappath=CS%7cCS%7cnav
// _cases&text=${this.caseid}&option=0&pagemode=iframe`,
import Viewer from "v-viewer/src/component.vue"

export default {
    components: {
        Viewer,
    },
    props: ["caseid"],
    data() {
        return {}
    },
    methods: {
        goto() {
            window.open(
                `https://hpcdax.crm.dynamics.com/main.aspx?appid=c4ac64fc-8e58-e911-a83c-000d3a3b7d47&pagetype=search&searchText=${this.caseid}&searchType=1`,
                "newwindow",
                "width=1500,height=700,scrollbars=yes,titlebar=no,left=250"
            )
        },
    },
}
</script>
